<template>
	<div class="mine">
		<div class="accont">
			<div class="title">
				<div class="name">
					<div class="padding"></div>
					密码管理
				</div>
			</div>
			<div class="content">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="原密码" prop="origin"><el-input v-model="ruleForm.origin" placeholder="请输入原密码"></el-input></el-form-item>
					<el-form-item label="新密码" prop="password"><el-input v-model="ruleForm.password" placeholder="请输入新密码"></el-input></el-form-item>
					<el-form-item label="确认新密码" prop="rptpassword"><el-input v-model="ruleForm.rptpassword" placeholder="请再次新密码"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
						<el-button @click="resetForm('ruleForm')">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
import api from '../../http/electrician/api.js';
export default {
	name: 'mine',
	data() {
		let verify_password = (rule, value, callback) => {
			if (this.ruleForm.password != this.ruleForm.rptpassword) {
				callback(new Error('两次输入的密码不一致'));
			} else {
				callback();
			}
		};
		return {
			ruleForm: {
				origin: null,
				password: null,
				rptpassword: null
			},
			rules: {
				origin: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
				password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
				rptpassword: [{ required: true, message: '请再次新密码', trigger: 'blur' }, { required: true, trigger: 'blur', validator: verify_password }]
			}
		};
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					let reg = /^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*? ])\S*$/
					if (reg.test(this.ruleForm.password) == false) {
						return this.$message("密码最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符");
					}
					api.electrician_info_password({
						pwd: this.ruleForm.origin,
						newPwd: this.ruleForm.password,
						cNewPwd: this.ruleForm.rptpassword
					}).then(res => {
						this.$message({
							message: '修改成功',
							type: 'success'
						});
					});
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		}
	},
	beforeCreate: function() {
		//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
	},
	created: function() {
		//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
	},
	beforeMount: function() {
		//模板编译/挂载之前
	},
	mounted: function() {
		//模板编译/挂载之后
	},
	beforeUpdate: function() {
		//组件更新之前
	},
	updated: function() {
		//组件更新之后
	},
	activated: function() {
		// for keep-alive，组件被激活时调用
	},
	deactivated: function() {
		// for keep-alive，组件被移除时调用
	},
	beforeDestory: function() {
		// 组件销毁调用
	},
	destoryed: function() {
		// 组件销毁后调用
	}
};
</script>

<style lang="less" scoped="scoped">
.accont {
	width: 100%;
	background: @vue-bg-color;
	padding: 0px @vue-spacing-row-lg;
	box-sizing: border-box;
}
.title {
	width: 100%;
	height: 50px;
	border-bottom: 1px solid @vue-border-color;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	.name {
		height: 100%;
		display: flex;
		align-items: center;
	}
	.padding {
		width: 4px;
		height: 16px;
		background: #ff5252;
		margin-right: @vue-spacing-row-sm;
	}
}
.content {
	width: 100%;
	padding: @vue-spacing-col-lg 0px @vue-spacing-col-lg*3 0px;
}
</style>
